import React, { useState } from "react";

interface TencentChat {
  (): {
    handlePushMessagesRecieved: (messages: TencentMessage) => void;
    selectedFromListConversation: TridentFoodMessage[];
    setSelectedFromListConversation: React.Dispatch<React.SetStateAction<TridentFoodMessage[]>>;
    listConversations: any[];
  };
}

const useTencentChat: TencentChat = () => {
  const [listConversations, setListConversations] = useState([]);
  const [selectedFromListConversation, setSelectedFromListConversation] = useState<TridentFoodMessage[]>([]);

  function mapTencentMessagesToBEMessages(messages: TencentMessage) {
    const speaker = messages.from.split("-");
    const objectMessages: TridentFoodMessage = {
      speaker: speaker[0] as "store" | "customer",
      speaker_id: speaker[1],
      message: messages.payload.text,
      timestamp: new Date(messages.time),
      data: {
        image_url: "",
      },
    };
    return objectMessages;
  }

  function handlePushMessagesRecieved(messages: TencentMessage) {
    const formatedMessage = mapTencentMessagesToBEMessages(messages);
    setSelectedFromListConversation(prev => {
      return [...prev, formatedMessage];
    });
  }

  return {
    listConversations,
    setListConversations,
    selectedFromListConversation,
    setSelectedFromListConversation,
    handlePushMessagesRecieved,
  };
};

export default useTencentChat;
